import React from 'react'
import { useLocation } from 'react-router-dom'
import { useStateContext } from '../../context/ContextProvider'
import { renderText } from '../hooks/TextVeiw'
import { useTranslation } from 'react-i18next'
import {IoIosCalendar} from "../icons"
import { ShareArticle } from '../utils'
import { BlogUrl } from '../../server'
import Related_Blogs from './Related_Blogs'

const C_BlogDetails = () => {
  const { currentLang } = useStateContext()
  const { t } = useTranslation()
  const location = useLocation()

  const {blogData} = location.state
  

  if (!blogData) {
    return (
      <div className="p-4 text-center">
        <p>{t("Blog not found")}</p>
      </div>
    )
  }
  
  const isAr = currentLang === "ar"
  const title = isAr ? blogData.title_Ar : blogData.title_En
  const description = isAr ? blogData.description_Ar : blogData.description_En

  return (
    <div className="dark:bk">
    <div className=' hidden  lg:flex   items-center bg-center w-full justify-center h-[600px] mb-4' >
    <img 
            src={blogData.background} 
            alt={title}
            className="w-full h-full   z-0 inset-0  opacity-60 object-cover"
          />
    <div className="bg-gradient-to-br rounded-xl absolute center z-10 from-light-glass1 to-light-glass2 dark:from-dark-glass1 dark:to-dark-glass2 p-5 border border-light-glassStrock2 dark:border-dark-glassStrock1 backdrop-blur-xl ">

      <h1 className='h3 text-light-blue dark:text-dark-link animated-gradient-text'>
        {title}
      </h1>
    </div>
    </div>

   
       <div className="container  pt-20 lg:pt-[1px] flex lg:flex-row flex-col  z-10  gap-5">
      <div className="max-w-4xl mx-auto bg-light-secondary dark:bg-dark-secondary rounded-xl p-6">
 
        <div className="w-full h-64 md:h-96 overflow-hidden rounded-xl mb-6">
          <img 
            src={blogData.image} 
            alt={title}
            className="w-full h-full object-cover"
          />
        </div>
        

        <p className="caption flex flex-row items-center justify-start gap-2 text-light-caption dark:text-dark-caption mb-4">
        <span><IoIosCalendar /></span><span>{blogData.date}</span> 
        </p>
        

        <h1 className="h4 md:h4 text-light-title dark:text-dark-title mb-6">
          {title}
        </h1>
        

        <div className="prose max-w-none">
          <p className="body-1  leading-relaxed md:leading-loose text-light-subtitle dark:text-dark-subtitle ">
            {renderText(description )}
          </p>
        </div>
        <div className="w-full  flex items-center justify-center">
        <ShareArticle 
    url={`${BlogUrl}${blogData?.id}`}
    title={title}
                />
        </div>
  
      </div>
      <Related_Blogs  id={blogData.id} />
    </div>

 
  </div>
  )
}

export default C_BlogDetails